import { render, staticRenderFns } from "./EditarDadoModal.vue?vue&type=template&id=374709c0&scoped=true"
import script from "./EditarDadoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditarDadoModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditarDadoModal.vue?vue&type=style&index=0&id=374709c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374709c0",
  null
  
)

export default component.exports